// extracted by mini-css-extract-plugin
export default {"resetPassword":"account-recovery_resetPassword__-1c93","textField":"account-recovery_textField__l+Jws","buttons":"account-recovery_buttons__YPI9j"};